import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate
} from "react-router-dom";

import ForgotPassword from "./Componanat/Firstpage.jsx";

function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* Default Route */}
        <Route
          path="/"
          element={
            <Navigate to="/partnerforgetpassword" />
          }
        />

        {/* Forgot Password Route With Token */}
        <Route
          path="/partnerforgetpassword/:token"
          element={<ForgotPassword />}
        />

      </Routes>
    </BrowserRouter>
  );
}

export default App;